<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="publicationOptions"
  :value="value"
  @input="update"
  :loading="loading"
  v-if="multipleOptions"
)
</template>

<script>
  import { mapStores } from 'pinia'
  import { usePublicationsStore } from '@/stores/publications'
  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Publication' }
      },

      name: {
        type: String,
        default() { return 'q[story_publications_publication_id_in][]' }
      },

      value: {
        type: Array,
        default() { return [] }
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(usePublicationsStore),

      publicationOptions() {
        return this.publicationsStore.allAsObject
      },

      multipleOptions() {
        return this.publicationsStore.hasMultiple
      }
    },

    async mounted() {
      await this.publicationsStore.fetchOnce()

      this.loading = false
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
